<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span class="currentSpan">参会回执</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <el-button type="primary" @click="exportData()"> 导出数据 </el-button>
      </div>
    </div>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            <span class="condition_item_lable">关键字：</span>
            <el-input
              v-model="listQuery.Key"
              placeholder="单位名称、姓名、电话"
              clearable
            ></el-input>
          </div>
          <div class="condition_item">
            <span class="condition_item_lable">是否参会：</span>
            <el-select
              v-model="listQuery.CancelAttendance"
              placeholder="请选择"
            >
              <el-option label="请选择是否参会" :value="null"> </el-option>
              <el-option label="参会" :value="false"> </el-option>
              <el-option label="不参会" :value="true"> </el-option>
            </el-select>
          </div>
          <div class="condition_item">
            <span class="condition_item_lable">是否签到：</span>
            <el-select v-model="listQuery.IsSignIn" placeholder="请选择">
              <el-option label="请选择是否签到" :value="null"> </el-option>
              <el-option label="未签到" :value="false"> </el-option>
              <el-option label="已签到" :value="true"> </el-option>
            </el-select>
          </div>
          <div class="condition_item" style="margin-right: 30px">
            <el-button type="primary" @click="search()"> 查询 </el-button>
            <el-button @click="reset()" size="small" plain> 重置 </el-button>
          </div>
          <div class="condition_item" v-show="sortOrderItems.length > 1">
            <span class="condition_item_lable">排序方式：</span>
            <el-radio-group
              v-model="listQuery.Sorting"
              size="mini"
              @change="sortRadioChange"
            >
              <el-radio-button
                :label="sortOrderItem.Sorting"
                v-for="(sortOrderItem, sortOrderItemIndex) in sortOrderItems"
                :key="'sortOrder' + sortOrderItemIndex"
              >
                {{ sortOrderItem.SortingText }}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="form_bar_btn">
          <div class="condition_item">
            <el-button type="primary" @click="exportData()">
              导出数据
            </el-button>
          </div>
        </div>
      </div>
      <el-table
        v-loading="tableLoading"
        :data="meetingReceiptItems"
        style="width: 100%"
        stripe
        border
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="60"
          align="center"
        ></el-table-column>
        <el-table-column property="CompanyName" label="单位" min-width="260">
        </el-table-column>
        <el-table-column label="是否会员单位" width="100">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.MemberNumber">会员单位</div>
              <div v-if="!scope.row.MemberNumber">非会员单位</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          property="MemberSort"
          label="单位排序"
          min-width="80"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              <div v-if="!scope.row.MemberSort">--</div>
              <div v-if="scope.row.MemberSort">{{ scope.row.MemberSort }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="UserName" label="姓名" width="100">
        </el-table-column>
        <el-table-column property="Post" label="职务" min-width="100">
        </el-table-column>
        <el-table-column label="是否合住" width="100">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.RoomState === 1">
                合住
                <span v-if="scope.row.SharePeopleName">
                  （{{ scope.row.SharePeopleName }}）
                </span>
              </div>
              <div v-if="scope.row.RoomState === 2">单住</div>
              <div v-if="scope.row.RoomState === 3">不住</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="Phone" label="电话" min-width="110">
        </el-table-column>
        <el-table-column
          property="FlightAndTrainNumber"
          label="航班车次"
          min-width="120"
        >
        </el-table-column>
        <el-table-column property="ArrivalTime" label="抵达时间" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.ArrivalTime">
              {{ scope.row.ArrivalTime | dateformat('yyyy-MM-DD HH:mm') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="住宿日期" header-align="center">
          <el-table-column
            min-width="100"
            header-align="center"
            align="center"
            v-for="(col, index) in meetingAccommodationDateItems"
            :property="col"
            :key="col + index"
            :label="col"
          >
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.AccommodationDateItems[index].AccommodationStatus ==
                  '不住'
                "
                style="color: red"
              >
                {{
                  scope.row.AccommodationDateItems[index].AccommodationStatus
                }}
              </span>
              <span
                v-if="
                  scope.row.AccommodationDateItems[index].AccommodationStatus ==
                  '住'
                "
                style="color: #409eff"
              >
                {{
                  scope.row.AccommodationDateItems[index].AccommodationStatus
                }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>
        <!-- <el-table-column property="CheckInDate" label="入住日期" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.CheckInDate">
              {{ scope.row.CheckInDate | dateformat('yyyy-MM-DD') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column property="CheckOutDate" label="退住日期" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.CheckOutDate">
              {{ scope.row.CheckOutDate | dateformat('yyyy-MM-DD') }}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column property="Remark" label="备注" min-width="120">
        </el-table-column>
        <el-table-column label="是否参会" width="80">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.CancelAttendance">不参会</div>
              <div v-if="!scope.row.CancelAttendance">参会</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否签到" width="80">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.IsSignIn" style="color: #5cb6ff">
                已签到<i class="el-icon-check"></i>
              </div>
              <div v-if="!scope.row.IsSignIn">未签到</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="SignInTime" label="签到时间" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.SignInTime">
              {{ scope.row.SignInTime | dateformat('yyyy-MM-DD HH:mm') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="openEditMeetingReceipt(scope.row)"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="deleteMeetingReceipt(scope.row)"
            >
              删除
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.MaxResultCount"
          :layout="pagination_layout"
          :total="listTotalCount"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="编辑"
      :visible.sync="editMeetingReceiptDialogVisible"
      custom-class="custom_dialog"
      :close-on-click-modal="false"
      @close="editMeetingReceiptDialogClose"
    >
      <el-row>
        <el-col :span="22" :offset="1">
          <el-form
            :model="receiptItem"
            :rules="receiptItemRules"
            ref="receiptForm"
            label-width="90px"
            class="demo-ruleForm"
            size="mini"
            :label-position="is_xs ? 'top' : 'left'"
          >
            <el-form-item label="单位：" prop="CompanyName">
              <el-select
                v-model="receiptItem.CompanyName"
                ref="receiptItemCompanyName"
                filterable
                allow-create
                default-first-option
                placeholder="请选择或者输入单位"
                style="width: 380px"
                @change="companyNameChange"
              >
                <el-option
                  v-for="(memberItem, memberItemIndex) in memberItems"
                  :key="memberItemIndex"
                  :label="memberItem.CompanyName"
                  :value="memberItem.CompanyName"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单位排序：" prop="MemberSort">
              <el-input
                v-model="receiptItem.MemberSort"
                oninput="value=value.replace(/[^\d]/g,'')"
                :max="1000000"
                autocomplete="off"
                placeholder="请输入排序序号"
              ></el-input>
            </el-form-item>
            <el-form-item label="姓名：" prop="UserName">
              {{ receiptItem.UserName }}
            </el-form-item>
            <el-form-item label="职务：" prop="Post">
              <!-- {{ receiptItem.Post }} -->
              <el-input
                v-model="receiptItem.Post"
                autocomplete="off"
                placeholder="请输入职务"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否合住：">
              <div v-if="receiptItem.IsShare">
                合住
                <span v-if="receiptItem.SharePeopleName">
                  （{{ receiptItem.SharePeopleName }}）
                </span>
              </div>
              <div v-if="!receiptItem.IsShare">单住</div>
            </el-form-item>
            <el-form-item label="电话：">
              {{ receiptItem.Phone }}
            </el-form-item>
            <el-form-item label="航班车次：">
              {{ receiptItem.FlightAndTrainNumber }}
            </el-form-item>
            <el-form-item label="抵达时间：">
              <span v-if="receiptItem.ArrivalTime">
                {{ receiptItem.ArrivalTime | dateformat('yyyy-MM-DD HH:mm') }}
              </span>
            </el-form-item>
            <!-- <el-form-item label="入住日期：">
              <span v-if="receiptItem.CheckInDate">
                {{ receiptItem.CheckInDate | dateformat('yyyy-MM-DD') }}
              </span>
            </el-form-item>
            <el-form-item label="退住日期：">
              <span v-if="receiptItem.CheckOutDate">
                {{ receiptItem.CheckOutDate | dateformat('yyyy-MM-DD') }}
              </span>
            </el-form-item> -->
            <el-form-item label="住宿日期：">
              <!-- <el-checkbox
                v-for="(
                  accommodationDateItem, accommodationDateItemIndex
                ) in receiptItem.meetingAccommodationDateList"
                v-model="accommodationDateItem.Checked"
                :key="'accommodationDate' + accommodationDateItemIndex"
                >{{ accommodationDateItem.Date }}</el-checkbox
              > -->
              <div
                v-for="(
                  accommodationDateItem, accommodationDateItemIndex
                ) in receiptItem.meetingAccommodationDateList"
                :key="accommodationDateItemIndex"
              >
                <input
                  type="checkbox"
                  :id="accommodationDateItem.Date"
                  v-model="accommodationDateItem.Checked"
                />
                <label :for="accommodationDateItem.Date">{{
                  accommodationDateItem.Date
                }}</label>
              </div>
            </el-form-item>
            <el-form-item label="备注：">
              {{ receiptItem.Remark }}
            </el-form-item>
            <el-form-item label="是否参会：" prop="CancelAttendance">
              <el-checkbox
                v-model="receiptItem.CancelAttendance"
                v-if="
                  meetingInfo.MeetingReceiptState === 1 ||
                  meetingInfo.MeetingReceiptState === 2
                "
              >
                取消参会
              </el-checkbox>
              <span
                v-if="
                  meetingInfo.MeetingReceiptState !== 1 &&
                  meetingInfo.MeetingReceiptState !== 2 &&
                  receiptItem.CancelAttendance
                "
              >
                不参会
              </span>
              <span
                v-if="
                  meetingInfo.MeetingReceiptState !== 1 &&
                  meetingInfo.MeetingReceiptState !== 2 &&
                  !receiptItem.CancelAttendance
                "
              >
                参会
              </span>
            </el-form-item>
            <el-form-item label="是否签到：" prop="IsSignIn">
              <el-checkbox
                v-model="receiptItem.IsSignIn"
                v-if="
                  meetingInfo.MeetingReceiptState === 3 ||
                  meetingInfo.MeetingReceiptState === 4
                "
              >
                签到
              </el-checkbox>
              <span
                v-if="
                  meetingInfo.MeetingReceiptState !== 3 &&
                  meetingInfo.MeetingReceiptState !== 4 &&
                  receiptItem.IsSignIn
                "
              >
                已签到
              </span>
              <span
                v-if="
                  meetingInfo.MeetingReceiptState !== 3 &&
                  meetingInfo.MeetingReceiptState !== 4 &&
                  !receiptItem.IsSignIn
                "
              >
                未签到
              </span>
            </el-form-item>
            <el-form-item label="签到时间：" prop="IsSignIn">
              <span v-if="receiptItem.SignInTime">
                {{ receiptItem.SignInTime | dateformat('yyyy-MM-DD HH:mm') }}
              </span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editMeetingReceiptDialogVisible = false">
          取 消
        </el-button>
        <el-button type="primary" @click="editMeetingReceipt()">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import meetingReceiptManagerApi from '../../../api/vote/meetingReceiptManager'
export default {
  name: 'MeetingReceipt',
  components: {

  },
  data () {
    return {
      meetingId: null,
      tableLoading: true,
      meetingReceiptItems: [],
      sortOrderItems: [],
      meetingAccommodationDateItems: [],
      listTotalCount: 0,
      currentPage: 1,
      Sorting: null,
      listQuery: {
        MeetingId: null,
        maxResultCount: 10,
        skipCount: 0,
        Key: null,
        IsSignIn: null,
        CancelAttendance: null
      },
      pagination_layout: 'prev, pager, next',
      editMeetingReceiptDialogVisible: false,
      receiptItem: {},
      receiptItemRules: {},
      memberItems: [],
      inputCompanyName: ''
    }
  },
  props: ['meetingInfo'],
  methods: {
    reset: function () {
      this.listQuery.Key = null
      this.listQuery.IsSignIn = null
      this.listQuery.CancelAttendance = null
      this.getMeetingReceiptList()
    },
    search: function () {
      this.currentPage = 1
      this.listQuery.skipCount = (this.currentPage - 1) * this.listQuery.maxResultCount
      this.getMeetingReceiptList()
    },
    getMeetingReceiptList: function () {
      this.tableLoading = true
      meetingReceiptManagerApi.getMeetingReceiptList(this.listQuery).then(data => {
        this.meetingAccommodationDateItems = data.MeetingAccommodationDateItems
        this.meetingReceiptItems = data.Items
        this.sortOrderItems = data.SortOrderItems
        if (!this.listQuery.Sorting) {
          this.listQuery.Sorting = 'CreateTime'
        }
        this.listTotalCount = data.TotalCount
        this.tableLoading = false
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    getCompanyList: function (receiptItem) {
      meetingReceiptManagerApi.getCompanyList({ CompanyId: this.meetingInfo.CompanyID }).then(data => {
        this.memberItems = data
        this.receiptItem = JSON.parse(JSON.stringify(receiptItem))
        const selectItem = this.memberItems.find(memberItem => memberItem.CompanyName === this.receiptItem.CompanyName)
        if (selectItem) {
          this.receiptItem.MemberSort = selectItem.Sort
          this.receiptItem.MemberNumber = selectItem.MemberNumber
        } else {
          this.receiptItem.MemberSort = null
          this.receiptItem.MemberNumber = null
        }
        this.receiptItem.meetingAccommodationDateList = JSON.parse(this.receiptItem.AccommodationDate)
        if (this.receiptItem.meetingAccommodationDateList.length <= 0) {
          this.meetingAccommodationDateItems.forEach(element => {
            const checkItem = {}
            checkItem.Date = element
            checkItem.Checked = false
            this.receiptItem.meetingAccommodationDateList.push(checkItem)
          })
        }
      }).catch(err => {
        this.memberItems = []
        this.receiptItem = JSON.parse(JSON.stringify(receiptItem))
        return err
      })
    },
    handleSizeChange (val) {
      this.listQuery.maxResultCount = val
      this.getMeetingReceiptList()
    },
    handleCurrentChange (val) {
      this.listQuery.skipCount = (val - 1) * this.listQuery.maxResultCount
      this.getMeetingReceiptList()
    },
    indexMethod (index) {
      return this.listQuery.skipCount + index + 1
    },
    openEditMeetingReceipt: function (item) {
      const _this = this
      _this.editMeetingReceiptDialogVisible = true
      if (_this.memberItems.length <= 0) {
        this.getCompanyList(item)
      } else {
        _this.receiptItem = JSON.parse(JSON.stringify(item))
        const selectItem = this.memberItems.find(memberItem => memberItem.CompanyName === _this.receiptItem.CompanyName)
        if (selectItem) {
          _this.receiptItem.MemberSort = selectItem.Sort
          _this.receiptItem.MemberNumber = selectItem.MemberNumber
        } else {
          _this.receiptItem.MemberSort = null
          _this.receiptItem.MemberNumber = null
        }
        _this.receiptItem.meetingAccommodationDateList = JSON.parse(_this.receiptItem.AccommodationDate)
        if (_this.receiptItem.meetingAccommodationDateList.length <= 0) {
          _this.meetingAccommodationDateItems.forEach(element => {
            const checkItem = {}
            checkItem.Date = element
            checkItem.Checked = false
            _this.receiptItem.meetingAccommodationDateList.push(checkItem)
          })
        }
      }
    },
    editMeetingReceiptDialogClose: function () {
      const _this = this
      _this.$refs.receiptForm.clearValidate()
    },
    companyNameChange: function (companyName) {
      const selectItem = this.memberItems.find(item => item.CompanyName === companyName)
      if (selectItem) {
        this.receiptItem.MemberSort = selectItem.Sort
        this.receiptItem.MemberNumber = selectItem.MemberNumber
      } else {
        this.receiptItem.MemberSort = null
        this.receiptItem.MemberNumber = null
      }
    },
    // companyNameBlur: function () {
    //   if (this.inputCompanyName.length > 0) {
    //     // this.receiptItem.CompanyName = this.inputCompanyName
    //     this.$set(this.receiptItem, 'CompanyName', this.inputCompanyName)
    //     // this.companyNameChange(this.inputCompanyName)
    //   }
    // },
    // dataFilter: function (val) {
    //   this.inputCompanyName = val
    // },
    editMeetingReceipt: function () {
      const _this = this
      _this.$refs.receiptForm.validate((valid) => {
        if (valid) {
          const editLoading = this.openLoading()
          _this.receiptItem.AccommodationDate = JSON.stringify(_this.receiptItem.meetingAccommodationDateList)
          console.log(_this.receiptItem.AccommodationDate)
          meetingReceiptManagerApi.managerEditMeetingReceipt(_this.receiptItem).then(data => {
            _this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功！',
              customClass: 'custom_message'
            })
            _this.editMeetingReceiptDialogVisible = false
            editLoading.close()
            _this.getMeetingReceiptList()
          }).catch(err => {
            editLoading.close()
            _this.editMeetingReceiptDialogVisible = false
            return err
          })
        } else {
          return false
        }
      })
    },
    sortRadioChange: function (val) {
      this.currentPage = 1
      this.listQuery.skipCount = (this.currentPage - 1) * this.listQuery.maxResultCount
      this.getMeetingReceiptList()
    },
    deleteMeetingReceipt: function (item) {
      this.$confirm('确认删除该条数据吗？单位名称：“' + item.CompanyName + '”', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('删除中…')
        meetingReceiptManagerApi.deleteMeetingReceipt({
          id: item.Id
        }).then(data => {
          openLoading.close()
          this.getMeetingReceiptList()
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    exportData: function () {
      const openLoading = this.openLoading('正在导出…')
      meetingReceiptManagerApi.exportMeetingReceiptList({
        MeetingId: this.$route.params.mid,
        IsSignIn: this.listQuery.IsSignIn,
        CancelAttendance: this.listQuery.CancelAttendance,
        Sorting: this.listQuery.Sorting
      }).then(data => {
        if (!data) {
          return
        }
        const fileName = this.meetingInfo.MeetingName + '参会回执信息汇总表'

        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    init: function () {
      this.meetingId = this.$route.params.mid
      this.listQuery.MeetingId = this.$route.params.mid
      this.getMeetingReceiptList()
    }
  },
  computed: {

  },
  created () {
    this.init()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
